import React from "react";
import { Navigate } from "react-router";
import { NavLink} from "react-router-dom";
import Base from "../Base";
import { Header } from "../Header";
import { Footer } from "../Footer";
import Letter from "./Letter";
import LetterEvents from "./LetterEvents";
import LetterFolders from "./LetterFolders";

export default class Letters extends Base {
    constructor(props) {
        super(props);

        this.state = {
            id: 1,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            controllerName: "letter",
            data: null,
            loading: true,
            page: 1,
            sort: '',
            per_page: 30,
            phrase: '',
            filters: {
                personId: this.isNull(props.PersonId) ? this.getDefaultGuid() : props.PersonId,
                number: "",
                personName: "",
                callerSection: props.CallerSection,
                letterFolderId: this.isNull(props.LetterFolderId) ? this.getDefaultGuid() : props.LetterFolderId,
                filter: this.isNull(props.Filter) ? 0 : props.Filter,
            },
            systemModuleId: 27,
            moduleAccessStatus: 1,
            letterIdToChangeFolder: null,
            selectedFolderId: this.getDefaultGuid()
        };

        if (localStorage.getItem('sort'))
            this.state.sort = localStorage.getItem('sort');
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.CallerSection !== this.props.CallerSection ||
            prevProps.LetterFolderId !== this.props.LetterFolderId
        ) {
            let filters = {
                ...this.state.filters,
                phrase: '',
                number: '',
                personName: '',
                callerSection: this.props.CallerSection,
                letterFolderId: this.isNull(this.props.LetterFolderId)
                    ? this.getDefaultGuid()
                    : this.props.LetterFolderId,
                filter: this.isNull(this.props.Filter)
                    ? 0
                    : this.props.Filter,
            };

            this.setState({ filters }, () => {
                this.httpPost("api/v1/common/check/module/access", {
                    systemModuleId: this.state.systemModuleId
                }).then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    this.setState(
                        { moduleAccessStatus: data.status },
                        () => this.refreshData()
                    );
                });
            });
        }
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({
            component: <Letter Caller={this} Source={1} CallerSection={this.state.filters.callerSection} />,
        });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <Letter Caller={this} Source={1} Id={id} CallerSection={this.state.filters.callerSection} />,
        });
    }
    showLetterEvents(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <LetterEvents Caller={this} LetterId={id} />,
        });
    }
    showLetterFolders() {
        this.removeKeyDown();
        this.showComponents({
            component: <LetterFolders Caller={this} />,
        });
    }
    saveFolder(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/letter/change/folder", {
            id: this.state.letterIdToChangeFolder,
            folderId: this.state.selectedFolderId,
        }).then((data) => {
            if (data.status === -1) window.location.href = "/login";
            this.state.innerStatus = data.innerStatus;
            if (data.status === 1) {
                this.showSuccessMessage("تغییر با موفقیت انجام پذیرفت");
                this.refreshData();
                this.setState({
                    letterIdToChangeFolder: null,
                    loading: false
                });
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    renderLetterFolderSelector() {
        if (this.state.letterIdToChangeFolder === null) return null;
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ height: "100%" }} onClick={(e) => this.setState({ letterIdToChangeFolder: null })}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ padding: "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={(e) => this.setState({ letterIdToChangeFolder: null })} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title">تغییر پرونده</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <label for="name" className="title1">
                                            پرونده ای که نامه در آن قرار میگیرد را انتخاب نمایید
                                        </label>
                                        <select
                                            type="text"
                                            defaultValue={this.state.selectedFolderId}
                                            onChange={(e) => this.state.selectedFolderId = e.target.value}
                                            className="form-control">
                                            <option value={this.getDefaultGuid()}>انتخاب نمایید</option>
                                                {this.state.data.global.letterFolders.map(folder => <option value={folder.id}>{folder.title}</option>)}
                                        </select>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={(e) => this.setState({ letterIdToChangeFolder: null })} >
                                انصراف
                            </button>
                            <button type="submit" name="bank_form_modal_submit" className="btn btn-success" onClick={(e) => this.saveFolder(e)}>
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            {this.renderLetterFolderSelector()}
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست {this.getCaptions()}</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} {this.getCaption()} یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        {this.canNew() && <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><span className="shortcut">F2 - </span><span>ایجاد {this.getCaption()} جدید</span></a>
                                        </li>}
                                        <li>
                                            <a className="hand btn btn-warning" onClick={e => this.showLetterFolders()}><span>پرونده های من</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderView()}
            </div>
        </div>
    }
    canRemove() {
        if (this.state.filters.callerSection === 'in' || this.state.filters.callerSection === 'out' ||
            this.state.filters.callerSection === 'internal') return true;
        return false;
    }
    canNew() {
        if (this.state.filters.callerSection === 'in' || this.state.filters.callerSection === 'out' ||
            this.state.filters.callerSection === 'internal') return true;
        return false;
    }
    getCaption() {
        if (this.state.filters.callerSection === 'in') return "نامه وارده";
        if (this.state.filters.callerSection === 'out') return "نامه صادره";
        if (this.state.filters.callerSection === 'internal') return "نامه داخلی";
        return "نامه";
    }
    getCaptions() {
        if (this.state.filters.callerSection === 'in') return "نامه های وارده";
        if (this.state.filters.callerSection === 'out') return "نامه های صادره";
        if (this.state.filters.callerSection === 'internal') return "نامه های داخلی";
        return "نامه ها";
    }
    getBackground(record) {
        if (record.needReply) return "#8000002b";
        if (record.read === false) return "#0080002b";

        return "";
    }
    renderView() {
        return <div className="nk-block">
            <div className="card card-bordered card-stretch">
                <div className="card-inner-group">
                    <div className="card-inner position-relative card-tools-toggle">
                        <div className="card-title-group">
                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                <div className="form-inline flex-nowrap gx-3">
                                    <div className="form-wrap">
                                        <input
                                            type="text"
                                            defaultValue={this.state.phrase}
                                            onChange={(e) =>
                                                (this.state.phrase = e.target.value)
                                            }
                                            placeholder="موضوع نامه"
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="form-wrap">
                                        <input
                                            type="text"
                                            defaultValue={this.state.filters.number}
                                            onChange={(e) => this.state.filters.number = e.target.value}
                                            placeholder="شماره نامه"
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="form-wrap">
                                        <input
                                            type="text"
                                            defaultValue={this.state.filters.personName}
                                            onChange={(e) =>
                                                (this.state.filters.personName = e.target.value)
                                            }
                                            placeholder="فرستنده/گیرنده"
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="form-wrap">
                                        <select
                                            defaultValue={this.state.filters.filter}
                                            onChange={(e) =>
                                                (this.state.filters.filter = parseInt(e.target.value))
                                            }
                                            className="form-control">
                                            <option value="0">همه نامه ها</option>
                                            <option value="1">نیازمند پاسخ</option>
                                            <option value="2">پیش نویس</option>
                                        </select>
                                    </div>
                                    <div className="form-wrap">
                                        <select
                                            defaultValue={this.state.sort}
                                            onChange={(e) => {
                                                this.state.sort = e.target.value;
                                                localStorage.setItem("sort", this.state.sort);
                                            }
                                            }
                                            className="form-control">
                                            <option value="">جدیدترین نامه ها به تفکیک وضعیت</option>
                                            <option value="editdate">جدیدترین تغییرات</option>
                                            <option value="number">شماره نامه (صعودی)</option>
                                            <option value="-number">شماره نامه (نزولی)</option>
                                        </select>
                                    </div>
                                    <div className="btn-wrap">
                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    {this.state.data.recordsCount <= 0 ?
                        <div className="card-inner-group">
                            <div className="example-alert">
                                <div className="alert alert-pro alert-warning">
                                    <div className="alert-text">
                                        <h6>توجه</h6>
                                        <p>{this.getCaption()} یافت نشد</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="card-inner p-0">
                            <div className="nk-tb-list nk-tb-ulist">
                                <div className="nk-tb-item nk-tb-head">
                                    <div className="nk-tb-col text-center"><span className="sub-text">موضوع</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">شماره</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">نوع</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">فرستنده</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">گیرنده</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">تاریخ</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>
                                    <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                </div>
                                {this.state.data.records.map((record, index) =>
                                    <div className="nk-tb-item" style={{ backgroundColor: this.getBackground(record) }}>
                                        <div className="nk-tb-col">
                                            <span className="onlyMobile">موضوع: </span>
                                            <span className="sub-text text-center">{record.subject}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="onlyMobile">شماره: </span>
                                            <span className="sub-text text-center">
                                                <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                    {record.fullNumber}
                                                </a>
                                            </span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="onlyMobile">نوع: </span>
                                            <span className="sub-text text-center">{record.typeString}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="onlyMobile">فرستنده: </span>
                                            <span className="sub-text text-center">{record.fromPersonString}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="onlyMobile">گیرنده: </span>
                                            <span className="sub-text text-center">{record.toPersonString}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="onlyMobile">تاریخ: </span>
                                            <span className="sub-text text-center">{record.dateString}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="onlyMobile">وضعیت: </span>
                                            <span className="sub-text text-center">{record.statusString}</span>
                                        </div>
                                        <div className="nk-tb-col text-end">
                                            <a
                                                className="hand text-success mx-1"
                                                onClick={(e) => this.showLetterEvents(record.id)}
                                                title="رخدادهای نامه"
                                            >
                                                <em className="icon ni ni-list"></em>
                                            </a>
                                            <a
                                                className="hand text-primary mx-1"
                                                onClick={(e) => this.getPdf(record.id)}
                                                title="چاپ نامه"
                                            >
                                                <em className="icon ni ni-printer"></em>
                                            </a>
                                            {this.canRemove() && record.status === -1 && <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                <em className="icon ni ni-cross-fill-c"></em>
                                            </a>}
                                            <a className="hand text-primary mx-1" onClick={e => this.setState({ letterIdToChangeFolder: record.id, selectedFolderId: this.getDefaultGuid() })} title="بایگانی">
                                                بایگانی
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                    {this.createPaging()}
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.isEmpty(this.state.data.global.companies) ? [
                    <Header data={this.state.data} />,
                    <div className="nk-content ">
                        <div className="container-fluid">
                            <div className="nk-content-inner">
                                {this.renderNoCompanyRegister()}
                            </div>
                        </div>
                    </div>,
                    <Footer />,
                ] :
                    this.state.inline ? this.renderView() :
                        [
                    <Header data={this.state.data} />,
                            <div className="nk-content ">
                                <div className="container-fluid">
                                    <div className="nk-content-inner">
                                        {this.renderForm()}
                                    </div>
                                </div>
                            </div>,
                    <Footer />,
                        ]
                ,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}